const Breakpoints = {
  sm: 0,
  md: 600,
  lg: 1200,
  xl: 1500,
  xxl: 1920
};

export default Breakpoints;
